import axios from "axios";
import { getStorage, setStorage, removeStorage } from "@/common/js/localstorage";
const request = axios.create({
  // baseURL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});

request.interceptors.request.use(
  (config) => {
    // 开发时需要注释这里，同时在 vue.config.js 开启代理
    config.baseURL = process.env.NODE_ENV === "production" ? window.baseUrl : "https://api.zxxuetang.com";
    if (getStorage("user") != undefined && getStorage("user").token) {
      config.headers.common["Authorization"] = "Bearer " + getStorage("user").token;
    } else {
      config.headers.common["Authorization"] = "";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    if (response.headers.new_token) {
      //判断返回头是否有new_token字段
      let storage = getStorage("user");
      //更新token
      storage.token = response.headers.new_token;
      setStorage("user", storage);
    }
    if (response.data.status == 10001) {
      //清除storage
      removeStorage("user");
      window.open(window.location.origin + "/#/login", "_self");
    }
    if (response.data.status == 401) {
      //清除storage
      removeStorage("user");
      window.open(window.location.origin + "/#/login", "_self");
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default request;
